const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { formatText } = require('core/i18n').i18n;
// @ components
const { InputSafe } = require('commonsComponents/inputSafe');

class AddBeneficiaryBankDetails extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: props.immAddBeneficiary.get('bankName'),
            address: props.immAddBeneficiary.get('bankAddress'),
            city: props.immAddBeneficiary.get('bankCity')
        }

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleBankNameChange = this.handleBankNameChange.bind(this);
        this.handleBankAddressChange = this.handleBankAddressChange.bind(this);
        this.handleBankCityChange = this.handleBankCityChange.bind(this);
        this.handleBankNameBlur = this.handleBankNameBlur.bind(this);
        this.handleBankAddressBlur = this.handleBankAddressBlur.bind(this);
        this.handleBankCityBlur = this.handleBankCityBlur.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.name !== nextProps.immAddBeneficiary.get('bankName')) {
            // This is the case when add beneficiary form is filled with existing beneficiary to be able to edit it.
            this.setState({
                name: nextProps.immAddBeneficiary.get('bankName'),
                address: nextProps.immAddBeneficiary.get('bankAddress'),
                city: nextProps.immAddBeneficiary.get('bankCity')
            });
        }
    }

    handleBankAddressBlur(evt) {
        this.props.actions.setBeneficiaryBankAddress(evt.target.value);
    }

    handleBankAddressChange(evt) {
        this.setState({
            address: evt.target.value
        });
    }

    handleBankCityBlur(evt) {
        this.props.actions.setBeneficiaryBankCity(evt.target.value);
    }

    handleBankCityChange(evt) {
        this.setState({
            city: evt.target.value
        });
    }

    handleBankNameBlur(evt) {
        this.props.actions.setBeneficiaryBankName(evt.target.value);
    }

    handleBankNameChange(evt) {
        this.setState({
            name: evt.target.value
        });
    }

    render() {
        const { immAddBeneficiary } = this.props;

        const labelName = formatText('transferSummary-step1BeneficiaryBankName');

        const nameRequiredAlertVisible = immAddBeneficiary.get('bankNameIsDirty') && immAddBeneficiary.get('bankName') === '';
        const nameRequiredErrorMsg = formatText('transferSummary-requiredMessage',[labelName]);

        const labelAddress = formatText('transferSummary-step1BeneficiaryBankAddress');
        const labelCity = formatText('transferSummary-step1BeneficiaryBankCity');

        return (
            <div className="add-beneficiary-step-one">
                <div className="add-beneficiary-step-one__form-section">
                    <InputSafe
                        type="text"
                        autoComplete="off"
                        label={labelName}
                        value={this.state.name}
                        onChange={this.handleBankNameChange}
                        onBlur={this.handleBankNameBlur}
                        errorState={nameRequiredAlertVisible}
                        errorMessage={nameRequiredErrorMsg}
                    />
                </div>
                <div className="add-beneficiary-step-one__form-section">
                    <InputSafe
                        type="text"
                        autoComplete="off"
                        label={labelAddress}
                        value={this.state.address}
                        onChange={this.handleBankAddressChange}
                        onBlur={this.handleBankAddressBlur}
                    />
                </div>
                <div className="add-beneficiary-step-one__form-section">
                    <InputSafe
                        type="text"
                        autoComplete="off"
                        label={labelCity}
                        value={this.state.city}
                        onChange={this.handleBankCityChange}
                        onBlur={this.handleBankCityBlur}
                    />
                </div>
            </div>
        );
    }
}

AddBeneficiaryBankDetails.propTypes = {
    actions: PropTypes.object,
    immAddBeneficiary: PropTypes.object
};

module.exports = AddBeneficiaryBankDetails;